import * as React from "react";
import {
  Grid,
  Divider,
  Button,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import withContext from "../../../tools/withContext";
import { fabric } from "fabric";
import DeleteIcon from "@material-ui/icons/Delete";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CopyIcon from "@material-ui/icons/FileCopy";
import BorderOuterIcon from "@material-ui/icons/BorderOuter";
import PaletteIcon from "@material-ui/icons/FormatColorFill";
import TuneIcon from "@material-ui/icons/TuneOutlined";
import BrushIcon from "@material-ui/icons/Brush";
import ClearIcon from "@material-ui/icons/Clear";
import AddIcon from "@material-ui/icons/Add";
import UndoIcon from "@material-ui/icons/Undo";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import MoveIcon from "@material-ui/icons/OpenWith";
import ZoomResetIcon from "@material-ui/icons/CropFree";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import StickModeIcon from "icons/StickMode";
import PasteIcon from "icons/Paste";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Icon, { StyledTooltip } from "./Icon";
import LabelerSegmentationUiStore, {
  ZOOM_MAX,
  ZOOM_MIN,
} from "../../../store/segmentation-store/labelerSegmentationUiStore";
import FabricSegmentationStore from "../../../store/segmentation-store/fabricSegmentationStore";
import LabelerSegmentationStore from "../../../store/segmentation-store/labelerSegmentationStore";
import deleteLastPointHandler from "../../../store/segmentation-store/deleteLastPointHandler";
import copyPolygonsHandler from "../../../store/segmentation-store/copyPolygonsHandler";
import pastePolygonsHandler from "../../../store/segmentation-store/pastePolygonsHandler";
import saveAndNextImageHandler from "../../../store/segmentation-store/saveAndNextImageHandler";

import ColorChanger from "./color-changer/index";
import ColorChangerPopUp from "./color-changer/color-changer-popUp";
import detectOS from "../tools/detectOS";
import StickModeHelper from "../stickModeHelp/StickModeHelper";
import StickTwoPolygonsStore from "store/segmentation-store/stickTwoPolygonsStore";
import { AspectRatio } from "@material-ui/icons";

const ActionDivider = ({ color }: any) => {
  return (
    <Grid item style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          borderLeft: `1px solid ${color ?? lighten("#000", 0.7)}`,
          height: "70%",
          margin: "0 4px",
        }}
      ></div>
    </Grid>
  );
};

const ActionIcon = (props: any) => {
  return (
    <Icon
      style={{
        borderRadius: "15%",
      }}
      {...props}
    />
  );
};

const Actions = ({
  labelerSegmentationUiStore,
  fabricSegmentationStore,
  labelerSegmentationStore,
  stickTwoPolygonsStore,
  ctx,
  history,
}: any) => {
  const {
    selectMode,
    setSelectMode,
    borderMode,
    deleteMode,
    setDeleteMode,
    addMode,
    setAddMode,
    polygons,
    areAllPolygonsDone,
    canSave,
    activePolygon,
    setZoom,
    zoom,
    isZoomIn,
    isZoomOut,
    moveInZoom,
    copyPolygons,
    setCopyPolygons,
    pastePolygons,
    setPastePolygons,
    hasSavedPolygons,
    findPolygonNotDone,
    setOpenSkipDialog,
    setOpenAlertDialog,
    setAlertDialogText,
    setAlertDialogCallback,
    toggleAllVisibility,
    setPolygons,
    resizeMode,
    setResizeMode,
  } = labelerSegmentationUiStore as LabelerSegmentationUiStore;

  const {
    stickMode,
    resetPolyStick,
    setStickMode,
    firstStickPolygon,
    secondStickPolygon,
    stickFinished,
    setStickFinished,
    polygonsBeforeStick,
  } = stickTwoPolygonsStore as StickTwoPolygonsStore;

  const {
    deleteSegmentByName,
    deleteAllSegments,
    numImage,
    batch,
    canNavigateToNextImage,
    canNvigateToPrevImage,
    isLoadingSave,
    currentTag,
    tags,
    isReadOnly,
  } = labelerSegmentationStore as LabelerSegmentationStore;

  const {
    toggleAllCanvasVisibility,
    canvas,
    resetZoomHandler,
    zoomInHandler,
  } = fabricSegmentationStore as FabricSegmentationStore;

  const { appFetch, user } = ctx;
  const userLogin = user?.login || user?.email || null;

  const [visibility, setVisibility] = React.useState<boolean>(true);
  const [changeLabeling, setChangeLabeling] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const getctrl = () => {
    const os = detectOS();
    switch (os) {
      case "macOS":
        return "⌘";
      case "winOS":
      default:
        return "CTRL";
    }
  };

  const disabledIcon = polygons.length === 0;
  const disableZoomIn = zoom >= ZOOM_MAX;
  const disableZoomOut = zoom <= ZOOM_MIN;
  const polygonNotDone = findPolygonNotDone();

  const ctrl = getctrl();

  React.useEffect(() => {
    if (polygons.length === 0) {
      setSelectMode(false);
    }
  }, [polygons]);

  React.useEffect(() => {
    if (copyPolygons) {
      setTimeout(() => {
        setCopyPolygons(false);
      }, 2000);
    }
  }, [copyPolygons]);

  React.useEffect(() => {
    if (pastePolygons) {
      setTimeout(() => {
        setPastePolygons(false);
      }, 2000);
    }
  }, [pastePolygons]);

  // HANDLERS /////////////////////////////
  /////////////////////////////////////////

  const handleAllVisibility = () => {
    setVisibility(!visibility);
    toggleAllVisibility(!visibility);
    setTimeout(() => {
      toggleAllCanvasVisibility(!visibility);
    }, 100);
  };

  const handleDeleteAllPolygons = () => {
    setAlertDialogText(
      "Êtes-vous sur de vouloir supprimer toutes les labellisations ?"
    );
    setAlertDialogCallback(deleteAllSegments);
    setOpenAlertDialog(true);
  };

  const handleDeleteSelectPolygon = () => {
    if (activePolygon) {
      setAlertDialogText(
        "Êtes-vous sur de vouloir supprimer la labellisation selectionée ?"
      );
      setAlertDialogCallback(() => {
        deleteSegmentByName(activePolygon.name);
        if (
          activePolygon.name === firstStickPolygon ||
          activePolygon.name === secondStickPolygon ||
          labelerSegmentationUiStore.polygons.filter(
            (p: any) => !p.labelValue.startsWith(activePolygon.name)
          ).length < 2
        ) {
          resetPolyStick();
        }
      });
      setOpenAlertDialog(true);
    }
  };

  const handleDesignMode = () => {
    if (disabledIcon) return;
    setSelectMode(false);
    setDeleteMode(false);
    setAddMode(false);
    setChangeLabeling(false);
    resetPolyStick();
    setStickFinished(false);
  };

  const handleEditMode = () => {
    if (disabledIcon) return;
    setSelectMode(true);
  };

  const handleDeleteLastPoint = () => {
    if (stickFinished) {
      setPolygons([...polygonsBeforeStick]);
      setStickFinished(false);
    } else {
      deleteLastPointHandler(labelerSegmentationUiStore.store);
    }
  };

  const handleZoomIn = () => {
    zoomInHandler();
  };

  const handleZoomOut = () => {
    const zoom = canvas.getZoom() - 0.1;
    // canvas.setZoom(zoom);
    canvas.zoomToPoint(new fabric.Point(0, 0), zoom);

    setZoom(zoom);
  };

  const handleResetZoom = () => {
    resetZoomHandler();
  };

  const handleDeleteMode = () => {
    setResizeMode(false);
    setAddMode(false);
    setDeleteMode(!deleteMode);
  };

  const handleAddMode = () => {
    setResizeMode(false);
    setDeleteMode(false);
    setAddMode(!addMode);
  };

  const handleCopyPolygons = () => {
    copyPolygonsHandler(labelerSegmentationUiStore.store);
  };

  const handlePastePolygons = () => {
    pastePolygonsHandler(labelerSegmentationUiStore.store);
  };

  const handleChangeLabeling = (event: any) => {
    const newchangeLabeling = !changeLabeling;
    setAnchorEl(newchangeLabeling ? event.currentTarget : null);
    setChangeLabeling(newchangeLabeling);
  };

  const handleCloseColorChangerPopUp = (event: any) => {
    // @ts-ignore
    if (anchorEl != null && anchorEl.contains(event.target)) {
      return;
    }
    setAnchorEl(null);
    setChangeLabeling(false);
  };

  const handleSave = () => {
    saveAndNextImageHandler(
      labelerSegmentationUiStore.store,
      appFetch,
      history,
      userLogin
    );
  };

  const goToNextImage = () => {
    setResizeMode(false);
    resetPolyStick();
    history.push(`/labelerSegmentation/${batch.id}/${Number(numImage) + 1}`);
  };

  const goToPrevImage = () => {
    setResizeMode(false);
    resetPolyStick();
    history.push(`/labelerSegmentation/${batch.id}/${Number(numImage) - 1}`);
  };

  const handleStickPolygons = () => {
    if (stickMode) {
      resetPolyStick();
    } else {
      setResizeMode(false);
      setStickMode(true);
    }
  };

  //////////////////////////////////////////////////

  return (
    <Grid container spacing={16} style={{ marginTop: 24 }}>
      {/* MODES  */}
      {!isReadOnly && (
        <Grid item container>
          <Grid item container justify="flex-start" xs={5}>
            <ActionIcon
              title="Mode dessin"
              disabled={false}
              component={BrushIcon}
              selected={!selectMode}
              selectable
              onClick={handleDesignMode}
            />
            <ActionDivider color={lighten("#000", 0.8)} />
            <ActionIcon
              title="Mode édition"
              disabled={disabledIcon || polygonNotDone}
              component={TuneIcon}
              selected={selectMode}
              selectable
              onClick={handleEditMode}
            />
            <Grid
              item
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: "8px",
              }}
            >
              <Typography>
                {selectMode ? "Mode édition" : "Mode dessin"}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            style={{
              justifyContent: "end",
            }}
            xs={7}
          >
            <StickModeHelper stickMode={stickMode as boolean} />
          </Grid>
        </Grid>
      )}

      {/* ACTIONS  */}
      {!isReadOnly && (
        <Grid
          item
          container
          justify="flex-start"
          style={{
            padding: "4px 10px",
            backgroundColor: lighten("#000", 0.98),
            borderRadius: "16px",
          }}
          xs={12}
        >
          <ActionIcon
            title={`${
              visibility ? "Cacher" : "Afficher"
            } toutes les labellisations`}
            disabled={disabledIcon}
            component={visibility ? VisibilityIcon : VisibilityOffIcon}
            onClick={handleAllVisibility}
          />
          <ActionDivider />
          <ActionIcon
            title="Supprimer toutes les labellisations"
            // disabled={!selectMode || disabledIcon}
            color={!disabledIcon ? "red" : ""}
            disabled={disabledIcon}
            component={DeleteForeverIcon}
            onClick={handleDeleteAllPolygons}
          />
          <ActionIcon
            title="Supprimer la labellisation selectionée"
            disabled={!activePolygon}
            component={DeleteIcon}
            onClick={handleDeleteSelectPolygon}
          />
          <ActionDivider />
          <Tooltip title={`formes copiées`} open={copyPolygons} placement="top">
            <ActionIcon
              title={`Copie les formes (${ctrl} + C)`}
              disabled={!canSave()}
              color={copyPolygons ? "green" : ""}
              component={CopyIcon}
              onClick={handleCopyPolygons}
            />
          </Tooltip>
          <Tooltip
            title={`formes collées`}
            open={pastePolygons}
            placement="top"
          >
            <ActionIcon
              title={`coller les formes sauvegardées (${ctrl} + V)`}
              disabled={!hasSavedPolygons()}
              color={pastePolygons ? "green" : ""}
              component={PasteIcon}
              onClick={handlePastePolygons}
            />
          </Tooltip>

          <ActionDivider />
          <ActionIcon
            title="Rester appuyer sur (b) pour créer les points sur le bord de l'image"
            disabled={selectMode}
            selected={borderMode}
            selectable
            component={BorderOuterIcon}
            onClick={() => {}}
          />
          <ActionIcon
            title="Supprimer des points"
            disabled={!selectMode}
            selected={deleteMode}
            selectable
            component={ClearIcon}
            onClick={handleDeleteMode}
          />
          <ActionIcon
            title="Ajouter des points"
            disabled={!selectMode}
            selected={addMode}
            selectable
            component={AddIcon}
            onClick={handleAddMode}
          />
          <ActionIcon
            title={`${
              resizeMode
                ? "Désactiver la redimension"
                : "Activer la redimension"
            }`}
            disabled={!selectMode || stickMode}
            selected={resizeMode}
            selectable
            component={AspectRatio}
            onClick={() => setResizeMode(!resizeMode)}
          />
          <ActionIcon
            title={`Coller 2 formes`}
            disabled={!selectMode || polygons.length < 2}
            selected={stickMode}
            selectable
            component={StickModeIcon}
            onClick={handleStickPolygons}
          />
          <ActionDivider />
          <ActionIcon
            title="Changer de classe"
            disabled={disabledIcon}
            selected={changeLabeling}
            selectable
            color={
              !disabledIcon ? currentTag.color : lighten(currentTag.color, 0.5)
            }
            component={PaletteIcon}
            onClick={handleChangeLabeling}
          />
          <ColorChangerPopUp
            open={changeLabeling}
            anchorEl={anchorEl}
            onClose={handleCloseColorChangerPopUp}
          >
            <ColorChanger tags={tags} />
          </ColorChangerPopUp>
          <ActionDivider />
          <Tooltip
            title={`x${zoom.toPrecision(2)}`}
            open={zoom > 1}
            placement="top"
          >
            <ActionIcon
              title="Zoomer (&uarr;)"
              disabled={disableZoomIn}
              selected={isZoomIn}
              selectable
              component={ZoomInIcon}
              onClick={handleZoomIn}
            />
          </Tooltip>
          <ActionIcon
            title="Dézoomer (&darr;)"
            disabled={disableZoomOut}
            selected={!disableZoomOut && isZoomOut}
            selectable
            component={ZoomOutIcon}
            onClick={handleZoomOut}
          />
          <ActionIcon
            title="Reset zoom (Esc)"
            disabled={zoom === 1}
            component={ZoomResetIcon}
            onClick={handleResetZoom}
          />
          <ActionIcon
            title="Rester appuyer sur (Shift) pour se déplacer"
            disabled={!isZoomIn}
            selected={moveInZoom}
            selectable
            component={MoveIcon}
            // onClick={handleMove}
          />          
          <ActionDivider />
          <ActionIcon
            title={
              stickFinished
                ? `Revenir à l'état précedent (${ctrl} + Z)`
                : `Supprime le dernier point (${ctrl} + Z)`
            }
            disabled={
              stickFinished ? false : selectMode || areAllPolygonsDone()
            }
            component={UndoIcon}
            onClick={handleDeleteLastPoint}
          />
        </Grid>
      )}

      {/* Divider */}

      <Grid item xs={12} style={{ padding: "8px" }}>
        {!isReadOnly && <Divider light />}
      </Grid>

      {/* BUTTONS */}

      <Grid
        item
        container
        direction="row"
        spacing={8}
        justify="flex-end"
        xs={12}
        style={{ height: 60 }}
      >
        {!isReadOnly && (
          <>
            <Grid item>
              <StyledTooltip title="Passer cette image en choisissant un motif" placement="top">
                <span>
                  <Button
                    color="secondary"
                    variant="outlined"
                    onClick={() => {
                      setOpenSkipDialog(true);
                      setResizeMode(false);
                    }}
                  >
                    Passer cette image
                  </Button>
                </span>
              </StyledTooltip>
            </Grid>
            <Grid item>
              <StyledTooltip
                title={`Sauvegarder et passer à l'image suivante (${ctrl} + S)`}
                placement="top"
              >
                <span>
                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleSave}
                    disabled={!canSave() || isLoadingSave}
                  >
                    {isLoadingSave ? "Sauvegarde..." : "Sauvegarder"}
                  </Button>
                </span>
              </StyledTooltip>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default withContext(
  withRouter(
    inject(
      "labelerSegmentationUiStore",
      "fabricSegmentationStore",
      "labelerSegmentationStore",
      "stickTwoPolygonsStore"
    )(observer(Actions))
  )
);
